import React from "react";
import cloth from "../../../../assets/webp/cloth.webp";

const totals = {
  platformFee: 0,
  tax: 1,
  deliveryFee: 2,
};

export default function SelectedServices({ orderDetail }) {
  // const totalAmount = orderDetail?.totalPrice + totals.platformFee + totals.tax + totals.deliveryFee;

  const serviceTotal = (orderDetail?.serviceItems || []).reduce(
    (sum, item) => sum + (Number(item?.price) || 0),
    0,
  );

  const additionalTotal = (orderDetail?.additionalItems || []).reduce(
    (sum, item) => sum + (Number(item?.total_price) || 0),
    0,
  );

  const shopDiscount =
    serviceTotal +
    additionalTotal -
    (Number(orderDetail?.priceDetails?.orderAmount) || 0);

  return (
    <div className="p-6 border border-[#D8DAE5] rounded-2xl bg-white shadow-sm w-full lgs:max-w-sm">
      <h2 className="text-lg font-bold text-[#063853] mb-4">
        {orderDetail?.serviceType}
      </h2>

      {orderDetail?.serviceItems.map((service, index) => (
        <div key={index}>
          <div className="flex justify-between items-start mb-1">
            <div className="flex items-center gap-3">
              <img src={cloth} alt="Cloth icon" className="w-6 h-6" />
              <div>
                <div className="text-base font-[500] text-[#2F2F2F]">
                  {service.item_name}
                </div>
                <div className="flex text-xs font-[500] text-[#666] space-x-0.5">
                  {service.quantity}
                  {orderDetail?.serviceType === "Wash & Fold" ? (
                    <span className="ml-1">lb</span>
                  ) : (
                    <span className="ml-1">Qty</span>
                  )}
                </div>
                {/* <div className="text-xs font-[500] text-[#666] space-y-0.5">
                  {service.descriptions.map((desc, i) => (
                    <p key={i}>{desc}</p>
                  ))}
                </div> */}
              </div>
            </div>
            <div className="text-base font-[600] text-[#2F2F2F]">
              ${service.price}
            </div>
          </div>
          {index < orderDetail?.serviceItems?.length - 1 && (
            <div className="border-t border-gray-200 my-2" />
          )}
        </div>
      ))}

      {orderDetail?.additionalItems?.length > 0 && (
        <div className="bg-[#e7f2f8] rounded-lg p-4">
          <div className="text-sm sm:text-base font-[600] text-[#2F2F2F] mb-[6px]">
            Selected Add Ons
          </div>
          {orderDetail?.additionalItems.map((addOns, index) => {
            const priceNum = parseFloat(addOns?.unit_price) || 0;
            const total = priceNum * addOns?.quantity;

            return (
              <div
                key={index}
                className="flex justify-between text-xs sm:text-sm font-[500] text-[#2F2F2F] mb-1"
              >
                <div className="flex gap-2">
                  <div>{addOns?.name}</div>
                  <div>x{addOns?.quantity}</div>
                </div>
                <div>${total}</div>
              </div>
            );
          })}
        </div>
      )}

      <div className="border-t border-black my-3"></div>

      {orderDetail?.priceDetails?.discount !== 0 && (
        <div className="flex justify-between ">
          <span className="font-[500]">Discount</span>
          <span className="font-[600] text-green-700">
            -${orderDetail?.priceDetails?.discount}
          </span>
        </div>
      )}

      {/* Fees */}
      <div className="flex justify-between mb-2">
        <span className="font-[500]">Order Estimate</span>
        <span className="font-[600]">
          ${orderDetail?.priceDetails?.orderAmount}
        </span>
      </div>
      <div className="mb-2 flex justify-between">
        <span className="font-[500]">Platform Amount</span>
        <span className="font-[600]">
          ${orderDetail?.priceDetails?.platformFee}
        </span>
      </div>
      <div className="mb-2 flex justify-between">
        <span className="font-[500]">Tax</span>
        <span className="font-[600]">${orderDetail?.priceDetails?.tax}</span>
      </div>
      <div className="flex justify-between mb-2">
        <span className="font-[500]">Delivery Partner Amount</span>
        <span className="font-[700]">
          ${orderDetail?.priceDetails?.deliveryCharge}
        </span>
      </div>
      <div className="flex justify-between mb-2">
        <span className="font-[500]">Tip</span>
        <span className="font-[600]">${orderDetail?.tip}</span>
      </div>

      {orderDetail?.priceDetails?.mismatchPaymentAmount > 0 && (
      <div className="flex justify-between ">
        <span className="font-[500]">Mismatch Amount</span>
        <span className="font-[600]">
          ${orderDetail?.priceDetails?.mismatchPaymentAmount || 0}
        </span>
      </div>)}
      
      <div className="flex justify-between ">
        <span className="font-[500]">Shop Discount</span>
        <span className="font-[600] text-green-700">
          -${shopDiscount.toFixed(2)}
        </span>
      </div>

      <div className="border-t border-gray-200 my-3"></div>
      <div className="flex justify-between text-lg text-[#2F2F2F]">
        <span className="font-[600]">Estimate Amount:</span>
        <span className="font-[600]">${orderDetail?.totalAmount}</span>
      </div>
    </div>
  );
}
